export var QueryExecutionStatus;
(function (QueryExecutionStatus) {
    QueryExecutionStatus["QUERY_EXECUTION_STATUS_UNSPECIFIED"] = "QUERY_EXECUTION_STATUS_UNSPECIFIED";
    QueryExecutionStatus["QUERY_EXECUTION_STATUS_QUEUED"] = "QUEUED";
    QueryExecutionStatus["QUERY_EXECUTION_STATUS_RUNNING"] = "RUNNING";
    QueryExecutionStatus["QUERY_EXECUTION_STATUS_SUCCEEDED"] = "SUCCEEDED";
    QueryExecutionStatus["QUERY_EXECUTION_STATUS_FAILED"] = "FAILED";
    QueryExecutionStatus["QUERY_EXECUTION_STATUS_CANCELLED"] = "CANCELLED";
})(QueryExecutionStatus || (QueryExecutionStatus = {}));
